import { classNames } from '@/utils/helpers'

import { useCampaigns } from '../state/hooks'

interface Props {
  className?: string
}
export const DiscountBadge = ({ className }: Props) => {
  const { currentDiscount } = useCampaigns()

  return (
    <p
      className={classNames(
        'shrink-0 rounded-full border border-danger-default px-3 py-2 text-xs font-semibold leading-[18px] text-danger-default',
        className,
      )}
    >
      {currentDiscount}% OFF
    </p>
  )
}
